import { createSlice } from "@reduxjs/toolkit";
import { Tenant } from "../interface/Tenant";

const initialState: Tenant | null = null;

const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    setTenantStore: (state: Tenant | null, action: any | null) => {
      return action.payload;
    },
    setTenantNull: (state, action) => {
      return null;
    }
  },
});

export const { setTenantStore, setTenantNull } = tenantSlice.actions;

export default tenantSlice.reducer;
